var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXCirculo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1060"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.3336 0C6.75136 0 5.2047 0.469255 3.88911 1.3483C2.57352 2.22735 1.548 3.47666 0.942504 4.93847C0.337004 6.40027 0.178583 8.00868 0.487264 9.56053C0.795945 11.1124 1.5579 12.5381 2.67671 13.6569C3.79553 14.7757 5.22105 15.5376 6.7729 15.8463C8.32474 16.155 9.93331 15.9964 11.3951 15.3909C12.8569 14.7854 14.1062 13.7599 14.9853 12.4443C15.8643 11.1287 16.3336 9.58223 16.3336 7.99998C16.3336 5.87826 15.4908 3.84338 13.9905 2.34309C12.4902 0.842806 10.4553 0 8.3336 0ZM10.5603 12.1064C10.4361 12.1103 10.3142 12.073 10.2136 12C10.1323 11.9247 10.0606 11.8397 10.0003 11.7467L8.25352 8.89321C8.20803 9.06123 8.14093 9.22274 8.05366 9.37335L6.52029 11.7467C6.45651 11.8371 6.38509 11.9217 6.30691 12C6.21049 12.0711 6.09338 12.1084 5.97358 12.1064H4.21366L7.02696 7.87987L4.3603 3.87987H6.26687C6.37189 3.85335 6.48184 3.85335 6.58686 3.87987C6.66503 3.92964 6.72928 3.99866 6.77355 4.08007L8.4936 6.82648C8.51866 6.73124 8.54977 6.63777 8.58686 6.54654L8.73367 6.27993L10.067 4.11978C10.1199 4.03309 10.1874 3.95648 10.2669 3.89322C10.3447 3.8508 10.4317 3.82785 10.5203 3.82649H12.3469L9.68028 7.70669L12.4936 12.0267L10.5603 12.1064Z",
    fill: "#DE4040"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXCirculo);
export default __webpack_public_path__ + "static/media/xCirculo.91de8e7910a4c932f6a1e8e464ca788a.svg";
export { ForwardRef as ReactComponent };